module.exports = __webpack_public_path__ + "static/fonts/ionicons.99ac330.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/iview/dist/styles/fonts/ionicons.woff?v=3.0.0
// module id = WpM7
// module chunks = 1